<template>
  <div>
    <!--Header Components-->
    <base-header class="pb-6" type="">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
          <h6 class="h2 d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <!--contents-->
    <b-container fluid class="mt--6 container-padding">
      <b-row>
        <div>
            <loading :active.sync="loading" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
        </div>
        <b-col lg="12">
          <div class="card-wrapper">
            <b-card no-body>
              <b-tabs pills card>
                <!--Basic information Tab-->
                <b-tab :title="language_terms['BASIC_INFORMATION']" active>
                  <b-card-text>
                    <card>
                      <div slot="header">
                        <b-row>
                          <b-col lg="6">
                              <h3>{{language_terms['BASIC_INFORMATION']}} 
                                  <span v-if="vendor.code">({{vendor.code}})</span>
                              </h3>
                          </b-col>
                          <!-- <b-col lg="6" >
                            <base-button icon type="danger" class="float-right" @click="deleteVendor" v-if="$route.params.id != '_new'">
                                <span class="btn-inner--text">{{language_terms['DELETE']}}</span>
                            </base-button>
                          </b-col> -->
                        </b-row>
                      </div>
                      <b-row>
                        <b-col md="12">
                          <base-input :label="language_terms['NAME']" v-model="vendor.name" :disabled="vendorDisabled"></base-input>
                        </b-col>
                      </b-row>
                      <b-row class="mb-4">
                        <!-- <b-col md="3">
                          <label class="form-control-label">{{language_terms['SALESPERSONS']}}</label>
                          <multiselect
                                  :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                  :placeholder="language_terms['SEARCH_ADD_TAG']"
                                  open-direction="bottom"
                                  label="name"
                                  track-by="linked_contact_id"
                                  :options="salesperson_list"
                                  text-field="name"
                                  :multiple="true"
                                  v-model="vendor.salepersons"
                                  :taggable="false"
                                  :disabled="vendorDisabled"
                          ></multiselect>
                        </b-col> -->
                        <b-col md="4">
                          <base-input :label="language_terms['COUNTRY']">
                            <el-select v-model="vendor.country_code" filterable :disabled="vendorDisabled">
                              <el-option v-for="option in countries" :key="option.code" :label="option.name" :value="option.code"></el-option>
                            </el-select>
                          </base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input :label="language_terms['CURRENCY']">
                            <el-select v-model="vendor.currency_code" filterable :disabled="vendorDisabled" :placeholder="language_terms['CURRENCY_CODE']">
                              <el-option v-for="option in currencies" :key="option.id" :label="option.code + ' (' + option.prefix + ')'" :value="option.code"></el-option>
                            </el-select>
                          </base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input :label="language_terms['TAX_CODE']">
                            <el-select :disabled="vendorDisabled" v-model="vendor.tax_code" filterable :placeholder="language_terms['TAX_CODE']">
                              <el-option v-for="option in taxes" :key="option.code" :label="option.code" :value="option.code">
                              </el-option>
                            </el-select>
                          </base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input :disabled="vendorDisabled" :label="language_terms['CREDIT_LIMIT']" type="number" v-model="vendor.vendor_credit_limit"></base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input :disabled="vendorDisabled" :label="language_terms['CREDIT_TERMS']" v-model="vendor.vendor_credit_term"></base-input>
                        </b-col>
                        <b-col md="12">
                          <base-input :label="language_terms['REMARKS']">
                            <textarea :disabled="vendorDisabled" class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="vendor.remarks"></textarea>
                          </base-input>
                        </b-col>
                        <b-col md="12" class="mt-2" v-if="!vendorDisabled">
                            <label class="form-control-label">{{language_terms['DEFAULT_CREDITOR_ACCOUNT_CODE']}}</label>
                            <multiselect
                                  v-model="vendor.default_crediotor_account_code"
                                  open-direction="bottom"
                                  :options="creditor_accounts"
                                  :searchable="true"
                                  :close-on-select="true"
                                  :show-labels="false"
                                  :placeholder="language_terms['SEARCH']"
                                 :disabled="vendorDisabled">
                          </multiselect>
                        </b-col>
                        <b-col md="12" class="mt-2" v-else>
                          <base-input disabled :label="language_terms['DEFAULT_CREDITOR_ACCOUNT_CODE']" v-model="vendor.default_crediotor_account_code"></base-input>
                        </b-col>
                      </b-row>
                    </card>
                    <card>
                      <h3 slot="header">
                        {{ language_terms["ADDRESS_INFORMATION"] }}
                      </h3>
                      <b-row>
                        <b-col md="12">
                          <base-input
                            :disabled="vendorDisabled"
                            :label="language_terms['STREET']"
                            type="text"
                            v-model="vendor.address_street"
                          ></base-input>
                        </b-col>
                        <!-- <b-col md="4">
                          <base-input label="City" v-model="vendor.address_city"></base-input>
                        </b-col> -->
                        <b-col md="4">
                          <base-input
                            :label="
                              language_terms['STATE'] +
                              '/' +
                              language_terms['PROVINCE']
                            "
                            v-model="vendor.address_province"
                            :disabled="vendorDisabled"
                          >
                          </base-input>
                        </b-col>
                        <b-col md="4">
                          <base-input
                            :disabled="vendorDisabled"
                            :label="language_terms['POSTCODE']"
                            v-model="vendor.address_postcode"
                          ></base-input>
                        </b-col>
                        <b-col md="4">
                          <base-input :label="language_terms['COUNTRY']">
                            <el-select :disabled="vendorDisabled" v-model="vendor.address_country_code" filterable>
                              <el-option
                                :disabled="vendorDisabled"
                                v-for="option in countries"
                                :key="option.code"
                                :label="option.name"
                                :value="option.code">
                              </el-option>
                            </el-select>
                          </base-input>
                          <!-- <base-input label="Country Code" v-model="vendor.address_country_code"></base-input> -->
                        </b-col>
                      </b-row>
                    </card>
                    <card>
                      <h3 slot="header">
                        {{ language_terms["CONTACT_INFO"] }}
                      </h3>
                      <b-row>
                        <b-col cols="2">
                          <base-input
                            :disabled="vendorDisabled"
                            :label="language_terms['CONTACT_PERSON']"
                            v-model="vendor.contact_person"
                          ></base-input>
                        </b-col>
                        <b-col cols="2">
                          <base-input
                            :disabled="vendorDisabled"
                            :label="language_terms['EMAIL']"
                            v-model="vendor.contact_email"
                          ></base-input>
                        </b-col>
                        <b-col cols="2">
                          <base-input
                            :disabled="vendorDisabled"
                            :label="language_terms['MOBILE']"
                            v-model="vendor.contact_mobile"
                          ></base-input>
                        </b-col>
                        <b-col cols="3">
                          <base-input
                            :disabled="vendorDisabled"
                            :label="language_terms['TELEPHONE']"
                            v-model="vendor.contact_telephone"
                          ></base-input>
                        </b-col>
                        <b-col cols="3">
                          <base-input
                            :disabled="vendorDisabled"
                            :label="language_terms['CONTACT_FAX']"
                            v-model="vendor.contact_fax"
                          ></base-input>
                        </b-col>
                      </b-row>
                    </card>
                  </b-card-text>
                  <div class="floating-bar">
                    <div class="floating-bar-container" align="center">
                      <b-button-group>
                        <b-button class="transparent-btn"  @click="editCustomer" v-if="vendorDisabled">
                          <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="saveCustomer" v-if="!vendorDisabled">
                          <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="cancelVendor" v-if="!vendorDisabled">
                          <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="deleteVendor" v-if="$route.params.id != '_new'">
                          <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                        </b-button>
                      </b-button-group>
                    </div>
                  </div>
                      <!-- <div>
                         <a href="javascript:void(0)" class="float-button" @click="editCustomer" style="background-color:#2dce89" v-if="vendorDisabled">
                            <i class="fas fa-edit my-float-button"></i>
                          </a>
                          <a href="javascript:void(0)" class="float-button "  @click="cancelVendor" style="background-color:#fb6340" v-if="!vendorDisabled">
                              <i class="fa fa-times  my-float-button" aria-hidden="true"></i>
                          </a>
                          <a href="javascript:void(0)" class="float-button mr-6" @click="saveCustomer" style="background-color:#5e72e4" v-if="!vendorDisabled">
                              <i class="fas fa-check my-float-button"></i>
                          </a>
                      </div> -->
                </b-tab>
                <b-tab :title="language_terms['BUSINESS_UNITS']" v-if="show_unit_tab">
                  <b-card-text>
                    <b-row>
                      <b-col lg="12" v-for="(item, index) of vendor.units" :key="index">
                        <b-card>
                            <b-row>
                              <b-col lg="10">
                                <h5 class="mb-0">{{ item.name }}</h5>
                              </b-col>
                              <b-col lg="2">
                                <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" class="float-right mr-1"><i class="fa fa-angle-down"></i></base-button>
                                <base-button @click="deleteUnit(item)" size="sm" icon type="danger" class="float-right mr-4"><i class="fas fa-trash-alt"></i ></base-button>
                              </b-col>
                            </b-row>
                            <b-collapse v-model="item.is_collapsed" class="mt-2">
                                <b-row>
                                  <b-col lg="12">
                                    <card>
                                  <h3 slot="header">
                                    {{ language_terms["BASIC_INFORMATION"] }}
                                  </h3>
                                  <b-row>
                                    <b-col md="12">
                                      <base-input
                                        label="Name"
                                        v-model="item.name"
                                      >
                                      </base-input>
                                    </b-col>
                                  </b-row>
                                  <b-row class="mb-4">
                                    <b-col md="4">
                                      <base-input
                                        :label="language_terms['COUNTRY']"
                                      >
                                        <el-select
                                          v-model="item.country_code"
                                          filterable
                                        >
                                          <el-option
                                            v-for="option in countries"
                                            :key="option.code"
                                            :label="option.name"
                                            :value="option.code"
                                          >
                                          </el-option>
                                        </el-select>
                                      </base-input>
                                    </b-col>
                                    <b-col md="4">
                                      <base-input
                                        :label="language_terms['CURRENCY']"
                                      >
                                        <el-select
                                          v-model="item.currency_code"
                                          filterable
                                          placeholder="Currency Code"
                                        >
                                          <el-option
                                            v-for="option in currencies"
                                            :key="option.id"
                                            :label="
                                              option.code +
                                              ' (' +
                                              option.prefix +
                                              ')'
                                            "
                                            :value="option.code"
                                          >
                                          </el-option>
                                        </el-select>
                                      </base-input>
                                    </b-col>
                                    <b-col md="4">
                                      <base-input
                                        :label="language_terms['TAX_CODE']"
                                      >
                                        <el-select
                                          v-model="item.tax_code"
                                          filterable
                                          :placeholder="
                                            language_terms['TAX_CODE']
                                          "
                                        >
                                          <el-option
                                            v-for="option in taxes"
                                            :key="option.code"
                                            :label="option.code"
                                            :value="option.code"
                                          >
                                          </el-option>
                                        </el-select>
                                      </base-input>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col md="6">
                                      <base-input
                                        :label="language_terms['CREDIT_LIMIT']"
                                        type="number"
                                        v-model="item.vendor_credit_limit"
                                      ></base-input>
                                    </b-col>
                                    <b-col md="6">
                                      <base-input
                                        :label="language_terms['CREDIT_TERMS']"
                                        v-model="item.vendor_credit_term"
                                      ></base-input>
                                    </b-col>
                                  </b-row>
                                    </card>
                                    <card>
                                      <h3 slot="header">
                                        {{ language_terms["ADDRESS_INFORMATION"] }}
                                      </h3>
                                      <b-row>
                                        <b-col md="12">
                                          <base-input
                                            :label="language_terms['STREET']"
                                            type="text"
                                            v-model="item.address_street"
                                          ></base-input>
                                        </b-col>
                                        <!-- <b-col md="4">
                                                <base-input label="City" v-model="item.address_city"></base-input>
                                              </b-col> -->
                                        <b-col md="4">
                                          <base-input :label="language_terms['STATE'] +'/' + language_terms['PROVINCE']" v-model="item.address_province"></base-input>
                                        </b-col>
                                        <b-col md="4">
                                          <base-input :label="language_terms['POSTCODE']" v-model="item.address_postcode"></base-input>
                                        </b-col>
                                        <b-col md="4">
                                          <base-input :label="language_terms['COUNTRY']">
                                            <el-select v-model="item.address_country_code" filterable>
                                              <el-option
                                                v-for="option in countries"
                                                :key="option.code"
                                                :label="option.name"
                                                :value="option.code">
                                              </el-option>
                                            </el-select>
                                          </base-input>
                                          <!-- <base-input label="Country Code" v-model="item.address_country_code"></base-input> -->
                                        </b-col>
                                      </b-row>
                                    </card>
                                    <card>
                                      <h3 slot="header">{{language_terms['CONTACT_INFO']}}</h3>
                                      <b-row>
                                        <b-col cols="4">
                                          <base-input
                                            :label="language_terms['CONTACT_PERSON']"
                                            v-model="item.contact_person"
                                          ></base-input>
                                        </b-col>
                                        <b-col cols="4">
                                          <base-input
                                            :label="language_terms['EMAIL']"
                                            v-model="item.contact_email"
                                          ></base-input>
                                        </b-col>
                                        <b-col cols="4">
                                          <base-input :label="language_terms['MOBILE']" v-model="item.contact_mobile"></base-input>
                                        </b-col>
                                        <b-col cols="4">
                                          <base-input :label="language_terms['TELEPHONE']" v-model="item.contact_telephone"></base-input>
                                        </b-col>
                                        <b-col cols="4">
                                          <base-input :label="language_terms['FAX']" v-model="item.contact_fax"></base-input>
                                        </b-col>
                                      </b-row>
                                    </card>
                                  </b-col>
                                  <b-col lg="12">
                                       <base-button @click="saveUnit(item)" type="primary" class="mr-1">{{language_terms['SAVE']}}</base-button>
                                  </b-col>
                                </b-row>
                            </b-collapse>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-card-text>
                  <div class="floating-bar">
                     <div class="floating-bar-container" align="center">
                       <b-button-group>
                          <b-button class="transparent-btn" @click="showaddUnitModal">
                             <i class="fas fa-plus mr-2 text-success"></i>{{language_terms['ADD']}}
                          </b-button>
                       </b-button-group>
                     </div>
                  </div>
<!-- 
                    <div>
                          <a href="javascript:void(0)" class="float-button "  @click="showaddUnitModal" style="background-color:#136b45" >
                                  <i class="fa fa-plus my-float-button"></i>
                          </a>
                      </div> -->
                </b-tab>
                <b-tab :title="language_terms['BANK_INFO']" v-if="show_unit_tab">
                    <bank-accounts :currencies="currencies" :countries="countries" :contact_id="vendor.id"  
                    :contact_code="vendor.code" :bank_accounts="bank_accounts"></bank-accounts>
                </b-tab>
                <b-tab :title="language_terms['CUSTOMIZED_PRICES'] + ' (' + vendor.customized_price_count + ')'">
                  <card>
                    <price-setup :customized_prices="vendor.customized_prices"  :code="vendor.code" :module="'vendor'"  :contact_id="vendor.id"></price-setup>
                  </card>    
                </b-tab>
              </b-tabs>
            </b-card>
            <b-modal
              v-model="addUnitModal"
              :header-bg-variant="headerBgVariant"
              :header-text-variant="headerTextVariant"
              size="xl"
              centered
              no-close-on-backdrop
              class="my-modal"
            >
              <template #modal-title>
                <span style="color: white">{{language_terms['NEW_BUSINESS_UNIT']}}</span>
              </template>
              <b-row>
                <b-col cols="12">
                  <card>
                    <h3 slot="header">{{language_terms['BASIC_INFORMATION']}}</h3>
                    <b-row>
                      <b-col md="12">
                        <base-input
                          :label="language_terms['NAME']"
                          v-model="business_unit_modal.name"
                        >
                        </base-input>
                      </b-col>
                    </b-row>
                    <b-row class="mb-4">
                      <b-col md="2">
                        <base-input :label="language_terms['COUNTRY']">
                          <el-select
                            v-model="business_unit_modal.country_code"
                            filterable
                          >
                            <el-option
                              v-for="option in countries"
                              :key="option.code"
                              :label="option.name"
                              :value="option.code"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col md="2">
                        <base-input :label="language_terms['CURRENCY']">
                          <el-select
                            v-model="business_unit_modal.currency_code"
                            filterable
                            :placeholder="language_terms['CURRENCY_CODE']"
                          >
                            <el-option
                              v-for="option in currencies"
                              :key="option.id"
                              :label="option.code + ' (' + option.prefix + ')'"
                              :value="option.code"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col md="2">
                        <base-input :label="language_terms['TAX_CODE']">
                          <el-select
                            v-model="business_unit_modal.tax_code"
                            filterable
                            :placeholder="language_terms['CURRENCY_CODE']"
                          >
                            <el-option
                              v-for="option in taxes"
                              :key="option.code"
                              :label="option.code"
                              :value="option.code"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col md="3">
                        <base-input
                          :label="language_terms['CREDIT_LIMIT']"
                          type="number"
                          v-model="business_unit_modal.vendor_credit_limit"
                        ></base-input>
                      </b-col>
                      <b-col md="3">
                        <base-input
                          :label="language_terms['CREDIT_TERMS']"
                          v-model="business_unit_modal.vendor_credit_term"
                        ></base-input>
                      </b-col>
                    </b-row>
                  </card>
                  <card>
                    <h3 slot="header">{{language_terms['CONTACT_INFO']}}</h3>
                    <b-row>
                      <b-col md="12">
                        <base-input
                          :label="language_terms['STREET']"
                          type="text"
                          v-model="business_unit_modal.address_street"
                        ></base-input>
                      </b-col>
                      <!-- <b-col md="4">
                          <base-input label="City" v-model="business_unit_modal.address_city"></base-input>
                        </b-col> -->
                      <b-col md="4">
                        <base-input
                          :label="
                            language_terms['STATE'] +
                            '/' +
                            language_terms['PROVINCE']
                          "
                          v-model="business_unit_modal.address_province"
                        >
                        </base-input>
                      </b-col>
                      <b-col md="4">
                        <base-input
                          :label="language_terms['POSTCODE']"
                          v-model="business_unit_modal.address_postcode"
                        ></base-input>
                      </b-col>
                      <b-col md="4">
                        <base-input :label="language_terms['COUNTRY']">
                          <el-select
                            v-model="business_unit_modal.address_country_code"
                            filterable
                          >
                            <el-option
                              v-for="option in countries"
                              :key="option.code"
                              :label="option.name"
                              :value="option.code"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                        <!-- <base-input label="Country Code" v-model="business_unit_modal.address_country_code"></base-input> -->
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="2">
                        <base-input
                          :label="language_terms['CONTACT_PERSON']"
                          v-model="business_unit_modal.contact_person"
                        ></base-input>
                      </b-col>
                      <b-col cols="2">
                        <base-input
                          :label="language_terms['EMAIL']"
                          v-model="business_unit_modal.contact_email"
                        ></base-input>
                      </b-col>
                      <b-col cols="2">
                        <base-input
                          :label="language_terms['MOBILE']"
                          v-model="business_unit_modal.contact_mobile"
                        ></base-input>
                      </b-col>
                      <b-col cols="3">
                        <base-input
                          :label="language_terms['TELEPHONE']"
                          v-model="business_unit_modal.contact_telephone"
                        ></base-input>
                      </b-col>
                      <b-col cols="3">
                        <base-input
                          :label="language_terms['FAX']"
                          v-model="business_unit_modal.contact_fax"
                        ></base-input>
                      </b-col>
                    </b-row>
                  </card>
                </b-col>
              </b-row>
              <template #modal-footer="{ ok, cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button variant="primary" @click="createBusinessUnit()">
                  {{language_terms['SAVE']}}
                </b-button>
                <b-button variant="danger" @click="cancelModal()">
                  {{language_terms['CANCEL']}}
                </b-button>
              </template>
            </b-modal>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import priceSetup from '../Components/vendorPriceSetup.vue';

import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import { mapState } from "vuex";
import { Select, Option } from "element-ui";
import bankAccounts from "../Components/bankAccounts.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data() {
    return {
      is_edit:false,
      vendorDisabled:true,
      loading:false,
      addUnitModal: false,
      show_unit_tab: false,
      headerBgVariant: "primary",
      headerTextVariant: "light",
      business_unit_modal: {
        name: "",
        country_code: "",
        vendor_credit_limit: "",
        vendor_credit_term: "",
        address_street: "",
        address_district: "",
        address_city: "",
        address_district: "",
        address_postcode: "",
        address_country_code: "",
        contact_person: "",
        contact_mobile: "",
        contact_telephone: "",
        contact_telephone: "",
        contact_fax: "",
        contact_email: "",
        remarks: "",
      },
      bank_accounts:[],
      vendor: {
        salepersons:[],
        customized_price_count:0,
        name: "",
        country_code: "",
        currency_code: "",
        vendor_credit_limit: "",
        vendor_credit_term: "",
        address_street: "",
        address_district: "",
        address_city: "",
        address_district: "",
        address_postcode: "",
        address_country_code: "",
        contact_person: "",
        contact_mobile: "",
        contact_telephone: "",
        contact_telephone: "",
        contact_fax: "",
        contact_email: "",
        remarks: "",
        bank_accounts:[],
        units: [
          {
            id: "",
            name: "",
            country_code: "",
            currency_code: "",
            vendor_credit_limit: "",
            vendor_credit_term: "",
            address_street: "",
            address_district: "",
            address_city: "",
            address_district: "",
            address_postcode: "",
            address_country_code: "",
            contact_person: "",
            contact_mobile: "",
            contact_telephone: "",
            contact_telephone: "",
            contact_fax: "",
            contact_email: "",
            remarks: "",
          },
        ],
      },
      options: ["list", "of", "options"],
    };
  },
  components: {
    Loading,
    bankAccounts,
    Collapse,
    CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    priceSetup
  },
  computed: {
    ...mapState({
      salesperson_list:state => state.employees.salesperson_list,
      vendor_filter: (state) => state.vendors.filter,
      currencies: (state) => state.currencies.currencies,
      taxes: (state) => state.taxes.taxes,
      countries: (state) => state.countries.countries,
      vendor_data: (state) => state.vendors.data,
      language_terms: (state) => state.languages.language_terms,
      selected_lang: (state) => state.languages.selected_langauge,
      vendor_is_created: (state) => state.vendors.is_created,
      vendor_is_updated: (state) => state.vendors.is_updated,
      vendor_is_deleted: (state) => state.vendors.is_deleted,
      creditor_accounts: (state) => state.vendors.creditor_accounts


    }),
  },
  watch:{
    'vendor.bank_accounts':{
        deep: true,
        handler(){
          this.bank_accounts = this.vendor.bank_accounts
        }
        
      },
      vendor_data:
        {
            deep:true,
            handler(){
                this.vendor = this.vendor_data
            }
        }
    
  },
  async mounted() {
    this.loading= true
    if (this.$route.params.id == "_new") 
    {
      this.show_unit_tab = false;
      this.vendorDisabled = false
    } 
    else 
    {
      await this.retirveVendor(this.$route.params.id);
      this.bank_accounts = this.vendor.bank_accounts
      this.show_unit_tab = true;
      this.vendorDisabled = true
    }

    await this.$store.dispatch("vendors/fetchCreditorAccounts", {})
    await this.$store.dispatch("countries/fetchAll");
    await this.fetchCurrencies();
    await this.fetchTaxes();
    await this.fetchSalesPersonsForCustomer();
    this.loading = false
  },
  methods: {
    handleCollaspe(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }

        console.log(row)

        this.$set(this.vendor.units, index , row) 
    },
    editCustomer()
    {
      this.vendorDisabled =false
      this.is_edit= true
    },
    async cancelModal() {
      this.addUnitModal = false;
    },
    async showaddUnitModal() {
      this.addUnitModal = true;
    },
    fetchSalesPersonsForCustomer() {
      this.$store.dispatch("employees/fetchAllSalesPersonForCustomer", {"role_code":"sales"});
    },
    async deleteVendor()
    {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE_DELETE'] + '?', this.language_terms['CONFIRMATION'], {
                  confirmButtonText: this.language_terms['YES'],
                  cancelButtonText: this.language_terms['CANCEL'],
                  type: 'warning'
                }).catch(() => {
              this.$message.info(this.language_terms['ACTION_CANCEL'])
             })
        if (response === 'confirm') 
        {
            this.loading =true
            await this.$store.dispatch("vendors/delete", this.vendor);

            if(this.vendor_is_deleted)
            {
                await this.searchCustomer();
                this.$router.push("/purchase/vendors");
            }
           
            this.loading =false
        }
    },
    async deleteUnit(item) 
    {
      if (item.id) 
      {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
                  confirmButtonText: this.language_terms['YES'],
                  cancelButtonText: this.language_terms['CANCEL'],
                  type: 'warning'
                }).catch(() => {
              this.$message.info(this.language_terms['ACTION_CANCEL'])
             })
        if (response === 'confirm') {
             this.loading =true
            await this.$store.dispatch("vendors/delete", item);
            await this.retirveVendor(this.$route.params.id);
            this.vendor = this.vendor_data;
             this.loading =false
        }
      }
    },
    async saveUnit(item) 
    {
      this.loading =true
      if (this.vendor.id && item.id) 
      {
        item.parent_id = this.vendor.id;
        await this.$store.dispatch("vendors/update", item);

        if(this.vendor_is_updated)
        {
          await this.retirveVendor(this.vendor.code)
        }
      }
      this.loading = false
    },
    async createBusinessUnit() {
      this.loading = true
      if (this.vendor.id) {
        this.business_unit_modal.parent_id = this.vendor.id;
        await this.$store.dispatch(
          "vendors/create",
          this.business_unit_modal
        );
        if(this.vendor_is_created)
        { 
            await this.retirveVendor(this.$route.params.id);
            this.vendor = this.vendor_data;

            this.business_unit_modal = {
                  name: "",
                  country_code: "",
                  vendor_credit_limit: "",
                  vendor_credit_term: "",
                  address_street: "",
                  address_district: "",
                  address_city: "",
                  address_district: "",
                  address_postcode: "",
                  address_country_code: "",
                  contact_person: "",
                  contact_mobile: "",
                  contact_telephone: "",
                  contact_telephone: "",
                  contact_fax: "",
                  contact_email: "",
                  remarks: ""
            }

            this.addUnitModal = false;

        }

        this.loading = false
      }
    },
    async retirveVendor(code) {
      this.loading =true
      await this.$store.dispatch("vendors/fetch", {
        code: code,
      });

      this.vendor = this.vendor_data;
      this.loading = false
    },
    addDepartment() {
      this.loading = true
      this.vendor.units.push({
        id: "",
        name: "",
        country_code: "",
        currency_code: "",
        vendor_credit_limit: "",
        vendor_credit_term: "",
        address_street: "",
        address_district: "",
        address_city: "",
        address_district: "",
        address_postcode: "",
        address_country_code: "",
        contact_person: "",
        contact_mobile: "",
        contact_telephone: "",
        contact_telephone: "",
        contact_fax: "",
        contact_email: "",
        remarks: "",
      });
      this.loading = false
    },
    fetchCurrencies() {
      this.loading = true
      this.$store.dispatch("currencies/fetchAll", {});
      this.loading = false
    },
    fetchTaxes() {
      this.loading= true
      this.$store.dispatch("taxes/fetchAll", { type: "Sales" });
      this.loading = false
    },
    async searchCustomer()
    {
        this.loading = true
        let filter = {keyword:"",active_only:"1"}
        if(this.vendor_filter)
        {
            filter = this.vendor_filter
        }
        await this.$store.dispatch('vendors/quickSearch', filter)

        this.loading = false
    },
    async saveCustomer() 
    {
      this.loading = true
      if (this.$route.params.id == "_new") 
      {
        await this.$store.dispatch("vendors/create", this.vendor);

        if(this.vendor_is_created)
        {
          // refresh the store
          await this.searchCustomer();
          this.$router.push("/purchase/vendors");
        }
      } 
      else 
      {
        await this.$store.dispatch("vendors/update", this.vendor);
        if(this.vendor_is_updated)
        {
            await this.searchCustomer();
            this.$router.push("/purchase/vendors");
        }
      }
      this.loading = false
    },
    cancelVendor() {
      location.reload();
    },
  },
};
</script>
